import React from 'react'
import {
  Card,
  CardBody,
  CardTitle,
  ListGroup,
  ListGroupItem,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  UncontrolledTooltip
} from 'reactstrap';
import { RenderButton } from '../../../../components';
import {
  capitalize,
  formatNumbersToCommaSeperated,
  showTitle,
  showTooltip,
} from '../../../../actions';
const LikesAudienceInterests = (props) => {
  return (
    <Card className="card-content-custom">
      <CardBody>
        <CardTitle>Audience Interests</CardTitle>
        <div className="card-content ch-8">
          {props.postAnalysisDetails &&
            props.postAnalysisDetails.audience_likers &&
            props.postAnalysisDetails.audience_likers.data && props.postAnalysisDetails.audience_likers.data.audience_interests && props.postAnalysisDetails.audience_likers.data.audience_interests.length ?
            <ListGroup className="icon-list">
              {props.postAnalysisDetails.audience_likers.data.audience_interests.map((interest, index) => {
                if (index < 5) {
                  return <ListGroupItem key={index} className="d-flex align-items-center pl-0">
                    <div className="mr-3">
                      <img src={props.generateImgUrl('interest', interest.id)} alt="img" /></div>
                    <div id={`likes_${interest.name}`} title={showTitle(`likes_${interest.name}`, interest.name)} className="text-wrap">
                      {capitalize(interest.name)}
                    </div>
                  </ListGroupItem>
                }
                return ""
              })}
            </ListGroup>
            : <span className="text-center text-grey "><p className="pt-50">No Record Found</p></span>}
        </div>
        {props.postAnalysisDetails &&
          props.postAnalysisDetails.audience_likers &&
          props.postAnalysisDetails.audience_likers.data && props.postAnalysisDetails.audience_likers.data.audience_interests && props.postAnalysisDetails.audience_likers.data.audience_interests.length ?
          <div className="bottom">
            <Button color="link" onClick={() => props.toggleModal("likesAudienceInterestsModal")}>View More</Button>
            <Modal id="likesAudienceInterestsModalDownload" isOpen={props.state.modals.likesAudienceInterestsModal} toggle={() => props.toggleModal("likesAudienceInterestsModal")} >
              <ModalHeader toggle={() => props.toggleModal("likesAudienceInterestsModal")}>
                <span className="tooltip-button-wrap"><span className="text-tooltip">Audience Interests</span>  <span href="#" id="likesAudienceInterestsModal" className="tooltip-icon"></span></span>
                <UncontrolledTooltip placement="bottom" className="tooltip-content" target="likesAudienceInterestsModal" >
                {showTooltip("likesAudienceInterestsModal")}
              </UncontrolledTooltip>
                <RenderButton onClick={() => props.downloadPdf("likesAudienceInterestsModalDownload")} className="download-icon-button mg-left-15 link">Download PDF</RenderButton>
              </ModalHeader>
              <ModalBody>
                <Table className="modal-table">
                  <thead>
                    <tr>
                      <th>Interests</th>
                      <th className="text-right">Likes</th>
                      <th className="text-right">Percentage</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.postAnalysisDetails &&
                      props.postAnalysisDetails.audience_likers &&
                      props.postAnalysisDetails.audience_likers.data && props.postAnalysisDetails.audience_likers.data.audience_interests ? props.postAnalysisDetails.audience_likers.data.audience_interests.map((interest, index) =>
                        <tr key={index}>
                          <th scope="row">
                            <div className="country-text-wrap">
                              <div className="flag-img brand-img">
                                <img src={props.generateImgUrl('interest', interest.id)} alt="img" /></div>
                              <div className="country-name">{capitalize(interest.name)}</div>
                            </div></th>
                          <td className="text-right">{formatNumbersToCommaSeperated((interest.weight) * props.postAnalysisDetails.posts_profile.likes)}</td>
                          <td className="text-right">{(interest.weight * 100).toFixed(2) + '%'}</td>
                        </tr>) :
                      <tr>
                        <td align="center" colSpan="3">No Record Found</td>
                      </tr>
                    }
                  </tbody>
                </Table>
              </ModalBody>
            </Modal>
          </div>
          : null}
      </CardBody>
    </Card>
  )
}

export default LikesAudienceInterests
